import { render, staticRenderFns } from "./RecycleDisposedItemModal.vue?vue&type=template&id=24afb1b3&scoped=true&"
import script from "./RecycleDisposedItemModal.vue?vue&type=script&lang=js&"
export * from "./RecycleDisposedItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afb1b3",
  null
  
)

export default component.exports